import { isEmpty, isEmail } from 'lib/utils/validator'
import { DebounceInput } from 'react-debounce-input'
import { setUserInfo } from 'lib/services/store'
import styles from './CartHeader.module.scss'

export default function CartHeader({ formData, children }) {
  /**
   * Handle changes in fields.
   * --> Save to state
   * --> Possibly trigger error state.
   */
  const handleChange = (value, key) => {
    // Trigger required validations.
    if (key === 'name') {
      if (isEmpty(value)) {
        formData.name.setError('Nimi on pakollinen kenttä')
      } else {
        formData.name.setError(null)
      }
    }

    if (key === 'email') {
      if (!isEmail(value)) {
        formData.email.setError('Tarkista sähköpostiosoite')
      } else {
        formData.email.setError(null)
      }
    }

    // Save to formstate.
    setUserInfo(key, value)
    formData[key].set(value)
  }

  /**
   * Check if we need error class for given key.
   */
  const getErrorClass = (key) => {
    const { error } = formData[key]

    if (error) {
      return styles.error
    }
  }

  return (
    <div className={`container ${styles.border}`}>
      {children}

      <form className={styles.form}>
        <div className={styles.formRow}>
          <label>
            Nimi
            <DebounceInput
              className={getErrorClass('name')}
              type="text"
              onChange={(e) => handleChange(e.target.value, 'name')}
              debounceTimeout={300}
              value={formData.name.value}
            />
          </label>
          {formData.name.error && (
            <p className={`error ${styles.errorMsg}`}>{formData.name.error}</p>
          )}
        </div>
        <div className={styles.formRow}>
          <label>
            Puhelinnumero (vapaaehtoinen)
            <input
              type="text"
              value={formData.phone.value}
              onChange={(e) => handleChange(e.target.value, 'phone')}
            />
          </label>
        </div>
        <div className={styles.formRow}>
          <label>
            Sähköpostiosoite
            <DebounceInput
              className={getErrorClass('email')}
              type="text"
              onChange={(e) => handleChange(e.target.value, 'email')}
              debounceTimeout={300}
              value={formData.email.value}
            />
          </label>
          {formData.email.error && (
            <p className={`error ${styles.errorMsg}`}>{formData.email.error}</p>
          )}
        </div>
        <div className={styles.formRow}>
          <label>
            Yritys (vapaaehtoinen)
            <input
              type="text"
              value={formData.company.value}
              onChange={(e) => handleChange(e.target.value, 'company')}
            />
          </label>
        </div>
      </form>
    </div>
  )
}
